import { Box, Divider, FormLabel } from "@chakra-ui/react";
import { ColumnDef } from "@tanstack/react-table";
import ActiveTag from "components/ui/ActiveTag";
import ButtonCreateNew from "components/ui/ButtonCreateNew";
import FilterGroup from "components/ui/FilterGroup";
import HeaderBar from "components/ui/HeaderBar";
import SearchInput from "components/ui/SearchInput";
import DynamicTableProvider, {
  useDynamicTableContext,
} from "contexts/DynamicTableContext";
import LayoutParameters from "features/auth/layouts/LayoutParameters";
import React from "react";
import PLsList from "../components/PLsList";

export default function PagePLs() {
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        header: "Nome",
        accessorKey: "name",
      },
      {
        header: "Status",
        accessorKey: "active",
        cell: ({ row }) => <ActiveTag isActive={row.original.active} />,
      },
    ],
    []
  );
  return (
    <LayoutParameters>
      <DynamicTableProvider
        columns={columns}
        resource={{
          resourceName: "pls",
        }}
        tableOptions={{
          enableGlobalFilter: false,
        }}
      >
        <HeaderBar
          title="Report → Proposições Legislativas"
          description="Visualize a lista de proposições legislativas Patri"
          px="0"
          sx={{
            h1: {
              mt: "0",
            },
          }}
        >
          <ButtonCreateNew title="Cadastrar nova" to="/pls/novo" />
        </HeaderBar>

        <Divider />

        <Box pt="24px">
          <Filters />
          <PLsList />
        </Box>
      </DynamicTableProvider>
    </LayoutParameters>
  );
}

function Filters() {
  const { table } = useDynamicTableContext();

  return (
    <FilterGroup justifyContent="space-between" pos="relative">
      <Box flex={1} minW="180px">
        <FormLabel>Buscar</FormLabel>
        <SearchInput
          placeholder="Buscar por nome"
          onChange={(value) =>
            table.getColumn("name")?.setFilterValue(String(value))
          }
        />
      </Box>
    </FilterGroup>
  );
}
